import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  categoryId: number;
  author: string;
  date: string;
  imageUrl: string;
  tags: string[];
  views: number;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  categoryId,
  author,
  date,
  imageUrl,
  tags,
  views,
}: ArticleCardProps) {
  const category = categories.find((c) => c.id === categoryId);

  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:bg-background-100 border border-background-200/70">
      <Link to={`/article/${id}`} className="block">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            title={title}
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          {category && (
            <Link
              to={`/category/${category.slug}`}
              className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 font-medium whitespace-nowrap hover:bg-accent-200 transition-colors"
            >
              {category.name}
            </Link>
          )}
          <span className="text-xs text-foreground-500 whitespace-nowrap">{date}</span>
        </div>
        <Link to={`/article/${id}`} className="block">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5 flex-wrap">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag} className="text-xs text-foreground-500 whitespace-nowrap">
                #{tag}
              </span>
            ))}
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-500 whitespace-nowrap">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views}
            </span>
            <span>{author}</span>
          </div>
        </div>
      </div>
    </article>
  );
}